import { z } from 'zod';

export const PaginationSchema = z.object({
  pageToken: z.string().optional(),
  count: z.number().optional(),
});

export const createPaginatedResponse = <T extends z.AnyZodObject>(schema: T) =>
  z.object({ items: schema.array(), nextToken: z.string().optional() });

export type PaginationQueryParams = z.infer<typeof PaginationSchema>;
